export const LOAD_STATS_CHARTS_REQUEST = 'LOAD_STATS_CHARTS_REQUEST';
export const LOAD_STATS_CHARTS_SUCCESS = 'LOAD_STATS_CHARTS_SUCCESS';
export const LOAD_STATS_CHARTS_FAILURE = 'LOAD_STATS_CHARTS_FAILURE';

export const LOAD_CHARTS_CONFIG_REQUEST = 'LOAD_CHARTS_CONFIG_REQUEST';
export const LOAD_CHARTS_CONFIG_SUCCESS = 'LOAD_CHARTS_CONFIG_SUCCESS';
export const LOAD_CHARTS_CONFIG_FAILURE = 'LOAD_CHARTS_CONFIG_FAILURE';

export const LOAD_CHARTS_CATEGORIES_REQUEST = 'LOAD_CHARTS_CATEGORIES_REQUEST';
export const LOAD_CHARTS_CATEGORIES_SUCCESS = 'LOAD_CHARTS_CATEGORIES_SUCCESS';
export const LOAD_CHARTS_CATEGORIES_FAILURE = 'LOAD_CHARTS_CATEGORIES_FAILURE';

export const LOAD_CHARTS_DATA_FLOW_REQUEST = 'LOAD_CHARTS_DATA_FLOW_REQUEST';
export const LOAD_CHARTS_DATA_FLOW_SUCCESS = 'LOAD_CHARTS_DATA_FLOW_SUCCESS';
export const LOAD_CHARTS_DATA_FLOW_FAILURE = 'LOAD_CHARTS_DATA_FLOW_FAILURE';

export const LOAD_CHARTS_FLOW_HAVE_DATA_REQUEST = 'LOAD_CHARTS_FLOW_HAVE_DATA_REQUEST';
export const LOAD_CHARTS_FLOW_HAVE_DATA_SUCCESS = 'LOAD_CHARTS_FLOW_HAVE_DATA_SUCCESS';

export const LOAD_CHARTS_REQUEST = 'LOAD_CHARTS_REQUEST';
export const LOAD_CHARTS_SUCCESS = 'LOAD_CHARTS_SUCCESS';

export const LOAD_CHARTS_FLOW_REQUEST = 'LOAD_CHARTS_FLOW_REQUEST';
export const LOAD_CHARTS_FLOW_SUCCESS = 'LOAD_CHARTS_FLOW_SUCCESS';

export const LOAD_CHARTS_CHARTS_REQUEST = 'LOAD_CHARTS_CHARTS_REQUEST';
export const LOAD_CHARTS_CHARTS_SUCCESS = 'LOAD_CHARTS_CHARTS_SUCCESS';

export const LOAD_CHARTS_DATA_REQUEST = 'LOAD_CHARTS_DATA_REQUEST';
export const LOAD_CHARTS_DATA_SUCCESS = 'LOAD_CHARTS_DATA_SUCCESS';

export const LOAD_SPECIAL_CHART_DATA_REQUEST = 'LOAD_SPECIAL_CHART_DATA_REQUEST';
export const LOAD_SPECIAL_CHART_DATA_SUCCESS = 'LOAD_SPECIAL_CHART_DATA_SUCCESS';

export const STATS_CHART_TYPE_LINE = 1;
export const STATS_CHART_TYPE_DOTTED_LINE = 2;
export const STATS_CHART_TYPE_PURE_LINE = 7;
export const STATS_CHART_TYPE_BAR = 3;
export const STATS_CHART_TYPE_STACKED_BAR = 4;

export const CHART_TYPE_PURE_LINE = 'CHART_TYPE_PURE_LINE';

export const STATS_CHART_DATAFLOW_PRIMARY_TYPE = 1;
export const STATS_CHART_DATAFLOW_SECONDARY_TYPE = 2;
export const STATS_CHART_DATAFLOW_ADDITIONAL_TYPE = 3;

export const STATS_CHART_MAIN_CATEGORY = 10;
